import uploadssettingsheaddefaulticonoutputPng from "$lib/data/generated/uploads/settings/Head/defaultIcon/output.png?as=run";

export const uploads = {
  "uploads/settings/Head/defaultIcon/output.png": uploadssettingsheaddefaulticonoutputPng
};